<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8.2 3.2h3.6v1.6a1.4 1.4 0 0 0 2.8 0V3.2h2.2v3.6h-1.6a1.4 1.4 0 0 0 0 2.8h1.6v3.6h-3.6v1.6a1.4 1.4 0 0 1-2.8 0v-1.6H6.8V9.6H5.2a1.4 1.4 0 0 1 0-2.8h1.6V3.2z"/></svg>
</template>
